import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { routerActions } from "react-router-redux/actions";
import { func, shape, boolean } from "prop-types";
import { signaturesSchemesTicketSelectors } from "reducers/administration";
import { signaturesSchemesTicketActions } from "reducers/administration/medium";

import AdministrationTicket from "pages/administration/_components/tickets/AdministrationTicket";
import SignaturesSchemeTicket from "pages/administration/_components/tickets/SignaturesScheme";
import PageLoading from "pages/_components/PageLoading";

class SignaturesSchemeTicketContent extends Component {
    static propTypes = {
        actions: func.isRequired,
        match: shape({}).isRequired,
        fetching: boolean,
    };

    static defaultProps = {
        fetching: false,
    };

    componentDidMount() {
        const { actions, match } = this.props;
        actions.loadSignaturesSchemesTicketRequest(match.params.idTransaction);
    }

    render() {
        const { fetching } = this.props;

        return (
            <PageLoading loading={fetching}>
                <AdministrationTicket {...this.props}>
                    <SignaturesSchemeTicket {...this.props} />
                </AdministrationTicket>
            </PageLoading>
        );
    }
}

const mapStateToProps = (state) => ({
    fetching: signaturesSchemesTicketSelectors.fetching(state),
    functionalGroups: signaturesSchemesTicketSelectors.functionalGroups(state),
    schemeName: "medium",
    signatureLevelsCounts: signaturesSchemesTicketSelectors.signatureLevelsCounts(state),
    signatureType: signaturesSchemesTicketSelectors.signatureType(state),
    topAmount: signaturesSchemesTicketSelectors.topAmount(state),
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(signaturesSchemesTicketActions, dispatch),
    routerActions: bindActionCreators(routerActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(SignaturesSchemeTicketContent);
